import React from "react";
import { Sparkles, ChevronDown, Check } from "lucide-react";
import { normalizePermissionFeatureName } from "../../../utils/permissionNormalization";
import { getWorkflowApprovalLabel } from "../Constant/EmployeeActions.config";

const CustomActionDropdown = ({
  t,
  styles,
  theme,
  isRTL,
  selectedAction,
  isDropdownOpen,
  setIsDropdownOpen,
  setSelectedAction,
  setErrorMsg,
  permissions,
  isAdminView,
  isAdminRole,
  hasFeatureAccess,
  ACTION_TYPES,
  ACTION_FEATURE_MAP,
  workflowDefinitions,
  language,
}) => {
  const selectedActionData = ACTION_TYPES.find((a) => a.id === selectedAction);
  const ActionIcon = selectedActionData?.icon || Sparkles;

  return (
    <div style={styles.customDropdown}>
      <div
        style={{
          ...styles.dropdownTrigger,
          borderColor: selectedAction
            ? selectedActionData.borderColor
            : theme === "dark"
            ? "rgba(255, 255, 255, 0.18)"
            : "rgba(0, 0, 0, 0.1)",
        }}
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        className="enhanced-input-focus"
      >
        <div style={styles.dropdownTriggerContent}>
          <div
            style={{
              ...styles.dropdownIconWrapper,
              background: selectedAction
                ? selectedActionData.color
                : "linear-gradient(135deg, #94a3b8, #64748b)",
            }}
          >
            <ActionIcon size={22} color="white" />
          </div>
          <div style={styles.dropdownTextWrapper}>
            <div style={styles.dropdownLabel}>
              {selectedAction
                ? t[selectedActionData.labelKey]
                : t.selectActionType}
            </div>
            <div style={styles.dropdownDescription}>
              {selectedAction
                ? t[selectedActionData.descriptionKey]
                : t.chooseAction}
            </div>
          </div>
        </div>
        <ChevronDown
          size={22}
          style={{
            ...styles.dropdownChevron,
            ...(isDropdownOpen ? styles.dropdownChevronOpen : {}),
          }}
        />
      </div>

      {isDropdownOpen && (
        <div style={styles.dropdownMenu}>
          {ACTION_TYPES.filter((action) => {
            if (!isAdminView || isAdminRole || !hasFeatureAccess) return true;
            const featureKey = ACTION_FEATURE_MAP[action.id] || null;
            if (!featureKey) return true;
            // hasFeatureAccess does the canonical, alias-aware lookup — the
            // old hand-rolled check here only ever read the exact
            // "changesPage" property/module spelling and silently hid any
            // granted action that didn't match that exact casing.
            return hasFeatureAccess("changesPage", featureKey);
          }).map((action) => {
            const ItemIcon = action.icon;
            const isSelected = selectedAction === action.id;
            return (
              <div
                key={action.id}
                style={{
                  ...styles.dropdownMenuItem,
                  ...(isSelected ? styles.dropdownMenuItemSelected : {}),
                }}
                onClick={() => {
                  setSelectedAction(action.id);
                  setIsDropdownOpen(false);
                  setErrorMsg("");
                }}
              >
                <div
                  style={{
                    ...styles.dropdownIconWrapper,
                    background: action.color,
                    width: "clamp(36px, 5.5vw, 42px)",
                    height: "clamp(36px, 5.5vw, 42px)",
                  }}
                >
                  <ItemIcon size={19} color="white" />
                </div>
                <div style={{ ...styles.dropdownTextWrapper, flex: 1 }}>
                  <div
                    style={{
                      ...styles.dropdownLabel,
                      fontSize: "clamp(13px, 1.9vw, 15px)",
                    }}
                  >
                    {t[action.labelKey]}
                  </div>
                  <div style={styles.dropdownDescription}>
                    {t[action.descriptionKey]}
                  </div>
                  <div
                    style={{
                      fontSize: "clamp(10px, 1.4vw, 11px)",
                      color:
                        theme === "dark" ? "rgba(255,255,255,0.5)" : "#94a3b8",
                      marginTop: "2px",
                    }}
                  >
                    {getWorkflowApprovalLabel(
                      action.id,
                      workflowDefinitions,
                      language,
                      t,
                      action.approvalLevelKey
                    )}
                  </div>
                </div>
                {isSelected && (
                  <Check
                    size={22}
                    style={{ color: "#2e7cba", flexShrink: 0 }}
                    strokeWidth={3}
                  />
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CustomActionDropdown;
